module.exports = __webpack_public_path__ + "static/img/sp_banner1.510ca7c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index/sp/sp_banner1.png
// module id = RqZS
// module chunks = 0